var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right_info"},[_c(_vm.component_name,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }